import {
    ChangeDetectorRef,
    Pipe,
    PipeTransform
} from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

/**
 * Translates `prefix + value` and falls back to the raw `value` when no translation
 * exists, instead of rendering the key itself (e.g. "userStates.Anwesend").
 *
 * Background: customers can define their own labels (user states, for example) that
 * will never be present in the i18n files. The standard texts stay translated,
 * everything else is shown exactly as the webservice delivers it.
 */
@Pipe({
    name: 'translateOrText',
    pure: false,
})
export class TranslateOrTextPipe extends TranslatePipe implements PipeTransform {
    constructor(translate: TranslateService, ref: ChangeDetectorRef) {
        super(translate, ref);
    }

    transform(value: string, prefix = ''): any {
        if (!value) {
            return value;
        }
        const key = `${prefix}${value}`;
        const translated = super.transform(key);

        return !translated || translated === key ? value : translated;
    }
}
